import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function Comp() {
    const { t } = useLang('powerBank.G');
    const { locale = 'us' } = useRouter();
    const dataA: EcoBannerProps = {
        layout: 'center-left',
        pc:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506643264/Frame%201612707671.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1753259272827/Frame%201612707559.jpg',
        pad: locale === 'ph' ? 'https://websiteoss.ecoflow.com/upload/image/1762506643264/Frame%201612707671.jpg' : '',
        h5:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762744634608/m%20new%2002.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1753259274156/Frame%201612707561.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        theme: 'white',
    };
    const [load, setLoad] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secneG = AniContainer.create({
                triggerElement: '.Rapid-F',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secneG.destroy();
            };
        }
    }, []);
    return (
        <div className={`temp-section-2 ${styles.comp} Rapid-G GtmModuleData-section`} data-section-id="Rapid-G" id="section-2">
            {load && <EcoBanner {...dataA} />}
        </div>
    );
}
